// Module
var code = "<div class=\"application-panel-container-table\">\r\n    <terceraPanel name='windowPanelBodyQT' />\r\n</div>";
// Exports
export default code;